<!--
    @component aggridCount 公用合计业务组件
    @props
        {String} flag  - 「头部」 或 「底部」合计
        {Array} countList -
          demoList:
            [
              { count: 1 },
              { title: '已到票未到货数量', count: 3, unit: '吨' },
              { title: '金额', count: 3, unit: '元' }
            ]
    @author 青木
    @date 2021-01-18 11:22:33
-->
<template>
  <span>
    <span v-for="(item,index) in countList" :key="index">
      <span v-if="item.key==='count'">
        {{ item.title?item.title:flag==='header'? $t('pagination.total') : $t('components.selected') }}
        <span class="count-color">{{ item.count }}</span>
        {{ $t('pagination.items') }}
        <template v-if="index !== countList.length - 1">,</template>
      </span>
      <!-- 第一个key是count并且他是最后一个则不显示 -->
      <span v-if="index===0 && !(item.key === 'count' && index === countList.length - 1)">{{ $t('grid.others.amountTo') }}: </span>
      <span v-if="item.key!=='count'">
        {{ item.title }}
        <span class="sum-color">{{ item.count }}</span>
        {{ item.unit }}
        <span v-if="index!==countList.length-1">
          ，
        </span>
      </span>
    </span>
  </span>
</template>
<script>
export default {
  name: 'GridTotal',
  props: {
    flag: {
      type: String,
      default: 'header'
    },
    countList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
